import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const checkMemberIdentity = async (email, personalId, scope = {}) => {
  try {
    const fn = httpsCallable(functions, "checkMemberIdentityV2");
    const result = await fn({
      email,
      personalId,
      operatingUnitId: scope.operatingUnitId,
      requestedApp: "dealership_web",
    });
    return result.data;
  } catch (error) {
    console.error("Error checando identidad del miembro:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "No se pudo validar la identidad. Intentá nuevamente.",
    };
  }
};
